import { useState } from 'react';
import { AFFILIATE_LINKS_ENABLED, getAffiliateUrl, getProductsByCategory } from '../../lib/affiliate-products';

export function AccessoriesSection() {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!AFFILIATE_LINKS_ENABLED) {
    return null;
  }

  const headphones = getProductsByCategory('headphones');
  const earbuds = getProductsByCategory('earbuds');
  const eyeMasks = getProductsByCategory('eye-mask');

  return (
    <div className="mt-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-center gap-2 py-2 text-sm text-parchment-400 dark:text-white/50 hover:text-parchment-text/80 dark:hover:text-white/70 transition-colors"
      >
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
        {isExpanded ? 'Hide Accessories' : 'Enhance Your Journey'}
      </button>

      {isExpanded && (
        <div className="glass rounded-xl p-5 mt-3 text-sm">
          <p className="text-parchment-500 dark:text-white/60 mb-4">
            Recommended accessories for your session:
          </p>

          {/* Headphones & Earbuds */}
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-base">🎧</span>
              <span className="font-medium text-parchment-text/80 dark:text-white/80">Audio</span>
            </div>
            <div className="space-y-1.5 ml-6">
              {[...headphones, ...earbuds].map((product) => (
                <a
                  key={product.id}
                  href={getAffiliateUrl(product.asin)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between group"
                >
                  <span className="text-parchment-500 dark:text-white/70 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
                    {product.shortName}
                    {product.category === 'headphones' && (
                      <span className="text-xs text-parchment-300 dark:text-white/40 ml-1">(over-ear)</span>
                    )}
                  </span>
                  <svg
                    className="w-4 h-4 text-parchment-300 dark:text-white/40 group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Eye Masks */}
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-base">😴</span>
              <span className="font-medium text-parchment-text/80 dark:text-white/80">Eye Mask</span>
            </div>
            <div className="space-y-1.5 ml-6">
              {eyeMasks.map((product) => (
                <a
                  key={product.id}
                  href={getAffiliateUrl(product.asin)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between group"
                >
                  <span className="text-parchment-500 dark:text-white/70 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
                    {product.shortName}
                  </span>
                  <svg
                    className="w-4 h-4 text-parchment-300 dark:text-white/40 group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Affiliate Disclosure */}
          <div className="pt-3 border-t border-black/10 dark:border-white/10">
            <p className="text-xs text-parchment-300 dark:text-white/40">
              As an Amazon Associate, we earn from qualifying purchases.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
